{
  "HELP_CENTER": {
    "TITLE": "Centre d'ajuda",
    "NEW_PAGE": {
      "DESCRIPTION": "Crea portals d'autoservei per al centre d'ajuda dels teus clients. Ajuda'ls a trobar respostes ràpidament, sense esperar. Simplifica les consultes, millora l'eficiència dels agents i millora l'atenció al client.",
      "CREATE_PORTAL_BUTTON": "Crea un portal"
    },
    "NEW_ARTICLE_PAGE": {
      "PLACEHOLDER_TITLE": "Sense títol"
    },
    "HEADER": {
      "FILTER": "Filtrat per",
      "SORT": "Ordenat per",
      "LOCALE": "Localització",
      "SETTINGS_BUTTON": "Configuracions",
      "NEW_BUTTON": "Nou article",
      "DROPDOWN_OPTIONS": {
        "PUBLISHED": "Publicat",
        "DRAFT": "Draft",
        "ARCHIVED": "Arxivat"
      },
      "TITLES": {
        "ALL_ARTICLES": "Tots els articles",
        "MINE": "Tots els meus articles",
        "DRAFT": "Esborrany d'articles",
        "ARCHIVED": "Articles arxivats"
      },
      "LOCALE_SELECT": {
        "TITLE": "Selecciona localització",
        "PLACEHOLDER": "Selecciona localització",
        "NO_RESULT": "No s'ha trobat localització",
        "SEARCH_PLACEHOLDER": "Cerca localització"
      }
    },
    "EDIT_HEADER": {
      "ALL_ARTICLES": "Tots els articles",
      "PUBLISH_BUTTON": "Publica",
      "MOVE_TO_ARCHIVE_BUTTON": "Mou a arxivat",
      "PREVIEW": "Vista prèvia",
      "ADD_TRANSLATION": "Afegeix traducció",
      "OPEN_SIDEBAR": "Obre la barra lateral",
      "CLOSE_SIDEBAR": "Tanca la barra lateral",
      "SAVING": "S'està desant...",
      "SAVED": "Desat"
    },
    "ARTICLE_EDITOR": {
      "IMAGE_UPLOAD": {
        "TITLE": "Puja imatge",
        "UPLOADING": "S'està carregant...",
        "SUCCESS": "La imatge s'ha carregat correctament",
        "ERROR": "S'ha produït un error en carregar la imatge",
        "UN_AUTHORIZED_ERROR": "No tens autorització per pujar imatges",
        "ERROR_FILE_SIZE": "La mida de la imatge ha de ser inferior a {size}MB",
        "ERROR_FILE_FORMAT": "El format de la imatge ha de ser JPG, JPEG o PNG",
        "ERROR_FILE_DIMENSIONS": "Les dimensions de la imatge han de ser inferiors a 2000 x 2000"
      },
      "ANCHOR": {
        "BUTTON": "Insereix àncora",
        "TITLE": "Insereix àncora",
        "SUBMIT": "Insereix",
        "PLACEHOLDER": "anchor-name"
      }
    },
    "ARTICLE_SETTINGS": {
      "TITLE": "Configuració de l'article",
      "FORM": {
        "CATEGORY": {
          "LABEL": "Categoria",
          "TITLE": "Selecciona categoria",
          "PLACEHOLDER": "Selecciona categoria",
          "NO_RESULT": "No s'ha trobat la categoria",
          "SEARCH_PLACEHOLDER": "Cerca la categoria"
        },
        "AUTHOR": {
          "LABEL": "Autor",
          "TITLE": "Selecciona l'autor",
          "PLACEHOLDER": "Selecciona l'autor",
          "NO_RESULT": "No s'han trobat autors",
          "SEARCH_PLACEHOLDER": "Cerca autor"
        },
        "META_TITLE": {
          "LABEL": "Meta títol",
          "PLACEHOLDER": "Afegeix un meta títol"
        },
        "META_DESCRIPTION": {
          "LABEL": "Meta descripció",
          "PLACEHOLDER": "Afegeix la teva meta descripció per obtenir millors resultats de SEO..."
        },
        "META_TAGS": {
          "LABEL": "Meta etiquetes",
          "PLACEHOLDER": "Afegeix meta etiquetes separades per comes..."
        }
      },
      "BUTTONS": {
        "ARCHIVE": "Arxiva article",
        "DELETE": "Suprimeix article"
      }
    },
    "ARTICLE_SEARCH_RESULT": {
      "UNCATEGORIZED": "Sense categoria",
      "SEARCH_RESULTS": "Resultats de la cerca per a {query}",
      "EMPTY_TEXT": "Cerca articles per inserir a les respostes.",
      "SEARCH_LOADER": "S'està cercant...",
      "INSERT_ARTICLE": "Insereix",
      "NO_RESULT": "No s'han trobat articles",
      "COPY_LINK": "Copia l'enllaç de l'article al porta-retalls",
      "OPEN_LINK": "Obre l'article en una pestanya nova",
      "PREVIEW_LINK": "Vista prèvia de l'article"
    },
    "PORTAL": {
      "HEADER": "Portals",
      "DEFAULT": "Per defecte",
      "NEW_BUTTON": "Nou portal",
      "ACTIVE_BADGE": "actiu",
      "CHOOSE_LOCALE_LABEL": "Escull una localització",
      "LOADING_MESSAGE": "Carregant portals...",
      "ARTICLES_LABEL": "articles",
      "NO_PORTALS_MESSAGE": "No hi ha portals disponibles",
      "ADD_NEW_LOCALE": "Afegeix una nova localització",
      "POPOVER": {
        "TITLE": "Portals",
        "PORTAL_SETTINGS": "Configuració del portal",
        "SUBTITLE": "Tens diversos portals i pots tenir diferents localitzacions per a cada portal.",
        "CANCEL_BUTTON_LABEL": "Cancel·la",
        "CHOOSE_LOCALE_BUTTON": "Escull localització"
      },
      "PORTAL_SETTINGS": {
        "LIST_ITEM": {
          "HEADER": {
            "COUNT_LABEL": "articles",
            "ADD": "Afegeix localització",
            "VISIT": "Visita el lloc",
            "SETTINGS": "Configuracions",
            "DELETE": "Esborra"
          },
          "PORTAL_CONFIG": {
            "TITLE": "Configuracions del portal",
            "ITEMS": {
              "NAME": "Nom",
              "DOMAIN": "Domini personalitzat",
              "SLUG": "Slug",
              "TITLE": "Títol del portal",
              "THEME": "Color del tema",
              "SUB_TEXT": "Subtext del portal"
            }
          },
          "AVAILABLE_LOCALES": {
            "TITLE": "Localitzacions disponibles",
            "TABLE": {
              "NAME": "Nom de la localització",
              "CODE": "Codi de la localització",
              "ARTICLE_COUNT": "Nre. d'articles",
              "CATEGORIES": "Nre. de categories",
              "SWAP": "Intercanvi",
              "DELETE": "Esborra",
              "DEFAULT_LOCALE": "Per defecte"
            }
          }
        },
        "DELETE_PORTAL": {
          "TITLE": "Suprimir portal",
          "MESSAGE": "Estàs segur que vols suprimir aquest portal",
          "YES": "Sí, esborra el portal",
          "NO": "No, manté el portal",
          "API": {
            "DELETE_SUCCESS": "Portal esborrat correctament",
            "DELETE_ERROR": "S'ha produït un error en suprimir el portal"
          }
        }
      },
      "EDIT": {
        "HEADER_TEXT": "Edita el portal",
        "TABS": {
          "BASIC_SETTINGS": {
            "TITLE": "Informació bàsica"
          },
          "CUSTOMIZATION_SETTINGS": {
            "TITLE": "Personalització del portal"
          },
          "CATEGORY_SETTINGS": {
            "TITLE": "Categories"
          },
          "LOCALE_SETTINGS": {
            "TITLE": "Localitzacions"
          }
        },
        "CATEGORIES": {
          "TITLE": "Categories a",
          "NEW_CATEGORY": "Nova categoria",
          "TABLE": {
            "NAME": "Nom",
            "DESCRIPTION": "Descripció",
            "LOCALE": "Localització",
            "ARTICLE_COUNT": "Nre. d'articles",
            "ACTION_BUTTON": {
              "EDIT": "Edita la categoria",
              "DELETE": "Suprimeix la categoria"
            },
            "EMPTY_TEXT": "No s'han trobat categories"
          }
        },
        "EDIT_BASIC_INFO": {
          "BUTTON_TEXT": "Actualitza la configuració bàsica"
        }
      },
      "ADD": {
        "CREATE_FLOW": {
          "BASIC": {
            "TITLE": "Informació del centre d'ajuda",
            "BODY": "Informació bàsica sobre el portal"
          },
          "CUSTOMIZATION": {
            "TITLE": "Personalització del centre d'ajuda",
            "BODY": "Personalitza el portal"
          },
          "FINISH": {
            "TITLE": "Llest! 🎉",
            "BODY": "Estàs a punt!"
          }
        },
        "CREATE_FLOW_PAGE": {
          "BACK_BUTTON": "Enrere",
          "BASIC_SETTINGS_PAGE": {
            "HEADER": "Crea un portal",
            "TITLE": "Informació del centre d'ajuda",
            "CREATE_BASIC_SETTING_BUTTON": "Crea la configuració bàsica del portal"
          },
          "CUSTOMIZATION_PAGE": {
            "HEADER": "Personalització del portal",
            "TITLE": "Personalització del centre d'ajuda",
            "UPDATE_PORTAL_BUTTON": "Actualitza la configuració del portal"
          },
          "FINISH_PAGE": {
            "TITLE": "Llest! 🎉 Estàs a punt!",
            "MESSAGE": "Ara pots veure aquest portal creat a la teva pàgina de tots els portals.",
            "FINISH": "Ves a la pàgina de tots els portals"
          }
        },
        "LOGO": {
          "LABEL": "Logo",
          "UPLOAD_BUTTON": "Puja el logo",
          "HELP_TEXT": "Aquest logotip es mostrarà a la capçalera del portal.",
          "IMAGE_UPLOAD_SUCCESS": "El logotip s'ha penjat correctament",
          "IMAGE_UPLOAD_ERROR": "El logotip s'ha suprimit correctament",
          "IMAGE_DELETE_ERROR": "S'ha produït un error en suprimir el logotip"
        },
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom del portal",
          "HELP_TEXT": "El nom s'utilitzarà internament al portal públic.",
          "ERROR": "El nom és obligatori"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug del portal per a URLs",
          "ERROR": "El slug és obligatori"
        },
        "DOMAIN": {
          "LABEL": "Domini personalitzat",
          "PLACEHOLDER": "Domini personalitzat del portal",
          "HELP_TEXT": "Afegeix-ho només si vols utilitzar un domini personalitzat per als teus portals. Ex: {exampleURL}",
          "ERROR": "Introdueix una URL de domini vàlida"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Enllaç a la pàgina d'inici",
          "PLACEHOLDER": "Enllaç a la pàgina d'inici del portal",
          "HELP_TEXT": "L'enllaç utilitzat per tornar del portal a la pàgina d'inici. Ex: {exampleURL}",
          "ERROR": "Introdueix una URL de pàgina d'inici vàlida"
        },
        "THEME_COLOR": {
          "LABEL": "Color del tema del portal",
          "HELP_TEXT": "Aquest color es mostrarà com a color del tema per al portal."
        },
        "PAGE_TITLE": {
          "LABEL": "Títol de la pàgina",
          "PLACEHOLDER": "Títol de la pàgina del portal",
          "HELP_TEXT": "El títol de la pàgina s'utilitzarà al portal públic.",
          "ERROR": "El títol de la pàgina és obligatori"
        },
        "HEADER_TEXT": {
          "LABEL": "Text de la capçalera",
          "PLACEHOLDER": "Text de la capçalera del portal",
          "HELP_TEXT": "El text de la capçalera del portal s'utilitzarà al portal públic.",
          "ERROR": "El text de la capçalera del portal és obligatori"
        },
        "API": {
          "SUCCESS_MESSAGE_FOR_BASIC": "Portal creat correctament.",
          "ERROR_MESSAGE_FOR_BASIC": "No s'ha pogut crear el portal. Torna-ho a provar.",
          "SUCCESS_MESSAGE_FOR_UPDATE": "Portal actualitzat correctament.",
          "ERROR_MESSAGE_FOR_UPDATE": "No s'ha pogut actualitzar el portal. Torna-ho a provar."
        }
      },
      "ADD_LOCALE": {
        "TITLE": "Afegeix una nova localització",
        "SUB_TITLE": "Això afegeix una nova localització a la teva llista de traduccions disponibles.",
        "PORTAL": "Portal",
        "LOCALE": {
          "LABEL": "Localització",
          "PLACEHOLDER": "Escull una localització",
          "ERROR": "La localització és obligatòria"
        },
        "BUTTONS": {
          "CREATE": "Crea una localització",
          "CANCEL": "Cancel·la"
        },
        "API": {
          "SUCCESS_MESSAGE": "La localització s'ha afegit correctament",
          "ERROR_MESSAGE": "No es pot afegir la localització. Torna-ho a provar."
        }
      },
      "CHANGE_DEFAULT_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "La localització predeterminada s'ha actualitzat correctament",
          "ERROR_MESSAGE": "No es pot actualitzar la localització predeterminada. Torna-ho a provar."
        }
      },
      "DELETE_LOCALE": {
        "API": {
          "SUCCESS_MESSAGE": "La localització s'ha eliminat del portal correctament",
          "ERROR_MESSAGE": "No es pot eliminar la localització del portal. Torna-ho a provar."
        }
      }
    },
    "TABLE": {
      "404": "No hi ha cap article que coincideixi amb la teva cerca 🔍",
      "LOADING_MESSAGE": "Carregant articles...",
      "NO_ARTICLES": "No hi ha articles disponibles",
      "HEADERS": {
        "TITLE": "Títol",
        "CATEGORY": "Categoria",
        "READ_COUNT": "Vistes",
        "STATUS": "Estat",
        "LAST_EDITED": "Última edició"
      },
      "COLUMNS": {
        "BY": "per",
        "AUTHOR_NOT_AVAILABLE": "L'autor no està disponible"
      }
    },
    "EDIT_ARTICLE": {
      "LOADING": "Carregant l'article...",
      "TITLE_PLACEHOLDER": "El títol de l'article va aquí",
      "CONTENT_PLACEHOLDER": "Escriu el teu article aquí",
      "API": {
        "ERROR": "S'ha produït un error en desar l'article"
      }
    },
    "PUBLISH_ARTICLE": {
      "API": {
        "ERROR": "S'ha produït un error en publicar l'article",
        "SUCCESS": "Article publicat amb èxit"
      }
    },
    "ARCHIVE_ARTICLE": {
      "API": {
        "ERROR": "S'ha produït un error en arxivar l'article",
        "SUCCESS": "Article arxivat correctament"
      }
    },
    "DRAFT_ARTICLE": {
      "API": {
        "ERROR": "S'ha produït un error en desar l'article com a esborrany",
        "SUCCESS": "Article desat com a esborrany correctament"
      }
    },
    "DELETE_ARTICLE": {
      "MODAL": {
        "CONFIRM": {
          "TITLE": "Confirma l'esborrat",
          "MESSAGE": "Estàs segur que vols suprimir l'article?",
          "YES": "Sí, esborra",
          "NO": "No, mantén-lo"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Article esborrat correctament",
        "ERROR_MESSAGE": "S'ha produït un error en suprimir l'article"
      }
    },
    "CREATE_ARTICLE": {
      "ERROR_MESSAGE": "Afegeix l'encapçalament i el contingut de l'article abans de poder actualitzar la configuració"
    },
    "SIDEBAR": {
      "SEARCH": {
        "PLACEHOLDER": "Cerca articles"
      }
    },
    "CATEGORY": {
      "ADD": {
        "TITLE": "Crea una categoria",
        "SUB_TITLE": "La categoria s'utilitzarà al portal públic per categoritzar els articles.",
        "PORTAL": "Portal",
        "LOCALE": "Localització",
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom de la categoria",
          "HELP_TEXT": "El nom i la icona de la categoria s'utilitzaran al portal públic per categoritzar els articles.",
          "ERROR": "El nom és obligatori"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de categoria per a URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "El slug és obligatori"
        },
        "DESCRIPTION": {
          "LABEL": "Descripció",
          "PLACEHOLDER": "Fes una breu descripció de la categoria.",
          "ERROR": "La descripció és obligatòria"
        },
        "BUTTONS": {
          "CREATE": "Crea la categoria",
          "CANCEL": "Cancel·la"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria creada correctament",
          "ERROR_MESSAGE": "No es pot crear la categoria"
        }
      },
      "EDIT": {
        "TITLE": "Edita una categoria",
        "SUB_TITLE": "L'edició d'una categoria actualitzarà la categoria al portal públic.",
        "PORTAL": "Portal",
        "LOCALE": "Localització",
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom de la categoria",
          "HELP_TEXT": "El nom i la icona de la categoria s'utilitzaran al portal públic per categoritzar els articles.",
          "ERROR": "El nom és obligatori"
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug de categoria per a URLs",
          "HELP_TEXT": "chat.jarabot.com/hc/my-portal/en-US/categories/my-slug",
          "ERROR": "El slug és obligatori"
        },
        "DESCRIPTION": {
          "LABEL": "Descripció",
          "PLACEHOLDER": "Fes una breu descripció de la categoria.",
          "ERROR": "La descripció és obligatòria"
        },
        "BUTTONS": {
          "CREATE": "Actualitza la categoria",
          "CANCEL": "Cancel·la"
        },
        "API": {
          "SUCCESS_MESSAGE": "Categoria actualitzada correctament",
          "ERROR_MESSAGE": "No es pot actualitzar la categoria"
        }
      },
      "DELETE": {
        "API": {
          "SUCCESS_MESSAGE": "Categoria suprimida correctament",
          "ERROR_MESSAGE": "No es pot suprimir la categoria"
        }
      }
    },
    "ARTICLE_SEARCH": {
      "TITLE": "Cerca articles",
      "PLACEHOLDER": "Cerca articles",
      "NO_RESULT": "No s'han trobat articles",
      "SEARCHING": "S'està cercant...",
      "SEARCH_BUTTON": "Cerca",
      "INSERT_ARTICLE": "Insereix enllaç",
      "IFRAME_ERROR": "L'URL és buit o no és vàlid. No es pot mostrar el contingut.",
      "OPEN_ARTICLE_SEARCH": "Insereix un article del Centre d'ajuda",
      "SUCCESS_ARTICLE_INSERTED": "Article inserit correctament",
      "PREVIEW_LINK": "Vista prèvia de l'article",
      "CANCEL": "Tanca",
      "BACK": "Enrere",
      "BACK_RESULTS": "Torna als resultats"
    },
    "UPGRADE_PAGE": {
      "TITLE": "Centre d'ajuda",
      "DESCRIPTION": "Crea portals d'autoservei fàcils d'utilitzar. Ajuda els teus usuaris a accedir als articles i obtenir assistència les 24 hores del dia. Actualitza la teva subscripció per activar aquesta funció.",
      "SELF_HOSTED_DESCRIPTION": "Crea portals d'autoservei fàcils d'utilitzar. Ajuda els teus usuaris a accedir als articles i obtenir assistència les 24 hores del dia. Posa't en contacte amb el teu administrador per activar aquesta funció.",
      "BUTTON": {
        "LEARN_MORE": "Aprèn més",
        "UPGRADE": "Actualitza"
      },
      "FEATURES": {
        "PORTALS": {
          "TITLE": "Múltiples portals",
          "DESCRIPTION": "Crea diversos portals del centre d'ajuda per a diferents productes amb el mateix compte."
        },
        "LOCALES": {
          "TITLE": "Suport total per a localitzacions",
          "DESCRIPTION": "Localitza el portal en el teu idioma. Admetem totes les localitzacions i permetem traduccions per a cada article."
        },
        "SEO": {
          "TITLE": "Disseny optimitzat per a SEO",
          "DESCRIPTION": "Personalitza les teves meta etiquetes per millorar la teva visibilitat als motors de cerca amb les nostres pàgines optimitzades per a SEO."
        },
        "API": {
          "TITLE": "Suport complet de l'API",
          "DESCRIPTION": "Utilitza el portal com a CMS sense capçalera amb frameworks de tercers per al front-end mitjançant les nostres API."
        }
      }
    },
    "LOADING": "S'està carregant...",
    "ARTICLES_PAGE": {
      "ARTICLE_CARD": {
        "CARD": {
          "VIEWS": "{count} visualització | {count} visualitzacions",
          "DROPDOWN_MENU": {
            "PUBLISH": "Publica",
            "DRAFT": "Draft",
            "ARCHIVE": "Arxiva",
            "DELETE": "Esborra"
          },
          "STATUS": {
            "DRAFT": "Draft",
            "PUBLISHED": "Publicat",
            "ARCHIVED": "Arxivat"
          },
          "CATEGORY": {
            "UNCATEGORISED": "Sense categoria"
          }
        }
      },
      "ARTICLES_HEADER": {
        "TABS": {
          "ALL": "Tots els articles",
          "MINE": "Meus",
          "DRAFT": "Draft",
          "PUBLISHED": "Publicat",
          "ARCHIVED": "Arxivat"
        },
        "CATEGORY": {
          "ALL": "Totes les categories"
        },
        "LOCALE": {
          "ALL": "Totes les localitzacions"
        },
        "NEW_ARTICLE": "Nou article"
      },
      "EMPTY_STATE": {
        "ALL": {
          "TITLE": "Escriu un article",
          "SUBTITLE": "Escriu un article complet, comencem!",
          "BUTTON_LABEL": "Nou article"
        },
        "MINE": {
          "TITLE": "Encara no has escrit cap article aquí",
          "SUBTITLE": "Tots els articles escrits per tu apareixeran aquí per a un accés ràpid."
        },
        "DRAFT": {
          "TITLE": "No hi ha articles en esborranys",
          "SUBTITLE": "Els articles en esborrany apareixeran aquí"
        },
        "PUBLISHED": {
          "TITLE": "No hi ha articles publicats",
          "SUBTITLE": "Els articles publicats apareixeran aquí"
        },
        "ARCHIVED": {
          "TITLE": "No hi ha articles a l'arxiu",
          "SUBTITLE": "Els articles arxivats no apareixen al portal; pots utilitzar-los per marcar pàgines obsoletes o desactualitzades"
        },
        "CATEGORY": {
          "TITLE": "No hi ha articles en aquesta categoria",
          "SUBTITLE": "Els articles d'aquesta categoria apareixeran aquí"
        }
      }
    },
    "CATEGORY_PAGE": {
      "CATEGORY_HEADER": {
        "NEW_CATEGORY": "Nova categoria",
        "EDIT_CATEGORY": "Edita la categoria",
        "CATEGORIES_COUNT": "{n} categoria | {n} categories",
        "BREADCRUMB": {
          "CATEGORY_LOCALE": "Categories ({localeCode})",
          "ACTIVE_CATEGORY": "{categoryName} ({categoryCount} articles) | {categoryName} ({categoryCount} article)"
        }
      },
      "CATEGORY_EMPTY_STATE": {
        "TITLE": "No s'han trobat categories",
        "SUBTITLE": "Les categories apareixeran aquí. Pots afegir-ne una fent clic al botó 'Nova categoria'."
      },
      "CATEGORY_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "EXPAND": "Mostra les subcategories",
        "COLLAPSE": "Amaga les subcategories",
        "MENU": {
          "NEW_ARTICLE": "Nou article",
          "ADD_SUBCATEGORY": "Afegeix subcategoria",
          "EDIT": "Edita",
          "DELETE": "Suprimeix"
        }
      },
      "CATEGORY_DIALOG": {
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria creada correctament",
            "ERROR_MESSAGE": "No es pot crear la categoria"
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria actualitzada correctament",
            "ERROR_MESSAGE": "No es pot actualitzar la categoria"
          }
        },
        "DELETE": {
          "API": {
            "SUCCESS_MESSAGE": "Categoria suprimida correctament",
            "ERROR_MESSAGE": "No es pot suprimir la categoria"
          },
          "CONFIRM": {
            "TITLE": "Suprimeix la categoria",
            "DESCRIPTION": "Estàs segur que vols suprimir aquesta categoria? Els seus articles quedaran sense categoria.",
            "DESCRIPTION_WITH_CHILDREN": "Estàs segur que vols suprimir aquesta categoria? Els seus articles quedaran sense categoria i la seva {count} subcategoria es mourà al nivell superior. | Estàs segur que vols suprimir aquesta categoria? Els seus articles quedaran sense categoria i les seves {count} subcategories es mouran al nivell superior.",
            "CONFIRM": "Suprimeix"
          }
        },
        "HEADER": {
          "CREATE": "Crea la categoria",
          "EDIT": "Edita la categoria",
          "DESCRIPTION": "L'edició d'una categoria actualitzarà la categoria al portal públic.",
          "PORTAL": "Portal",
          "LOCALE": "Localització"
        },
        "FORM": {
          "NAME": {
            "LABEL": "Nom",
            "PLACEHOLDER": "Nom de la categoria",
            "ERROR": "El nom és obligatori"
          },
          "SLUG": {
            "LABEL": "Slug",
            "PLACEHOLDER": "Slug de categoria per a URLs",
            "ERROR": "El slug és obligatori",
            "HELP_TEXT": "chat.jarabot.com/hc/{portalSlug}/{localeCode}/categories/{categorySlug}"
          },
          "DESCRIPTION": {
            "LABEL": "Descripció",
            "PLACEHOLDER": "Fes una breu descripció de la categoria.",
            "ERROR": "La descripció és obligatòria"
          },
          "PARENT_CATEGORY": {
            "LABEL": "Categoria pare",
            "PLACEHOLDER": "Selecciona una categoria pare",
            "NONE": "Cap (nivell superior)"
          }
        },
        "BUTTONS": {
          "CREATE": "Crea",
          "EDIT": "Actualitza",
          "CANCEL": "Cancel·la"
        }
      }
    },
    "LOCALES_PAGE": {
      "LOCALES_COUNT": "No hi ha localitzacions disponibles | {n} localització | {n} localitzacions",
      "NEW_LOCALE_BUTTON_TEXT": "Nova localització",
      "LOCALE_CARD": {
        "ARTICLES_COUNT": "{count} article | {count} articles",
        "CATEGORIES_COUNT": "{count} categoria | {count} categories",
        "DEFAULT": "Per defecte",
        "DROPDOWN_MENU": {
          "MAKE_DEFAULT": "Estableix com a predeterminada",
          "DELETE": "Esborra"
        }
      },
      "ADD_LOCALE_DIALOG": {
        "TITLE": "Afegeix una nova localització",
        "DESCRIPTION": "Selecciona l'idioma en què s'escriurà aquest article. S'afegirà a la teva llista de traduccions i en podràs afegir més més endavant.",
        "COMBOBOX": {
          "PLACEHOLDER": "Selecciona localització..."
        },
        "API": {
          "SUCCESS_MESSAGE": "La localització s'ha afegit correctament",
          "ERROR_MESSAGE": "No es pot afegir la localització. Torna-ho a provar."
        }
      }
    },
    "EDIT_ARTICLE_PAGE": {
      "HEADER": {
        "STATUS": {
          "SAVING": "S'està desant...",
          "SAVED": "Desat"
        },
        "PREVIEW": "Vista prèvia",
        "PUBLISH": "Publica",
        "DRAFT": "Draft",
        "ARCHIVE": "Arxiva",
        "BACK_TO_ARTICLES": "Torna als articles"
      },
      "DRAFT": {
        "PENDING_LABEL": "Canvis sense publicar",
        "PROMOTE": "Publica els canvis",
        "DISCARD": "Descarta els canvis",
        "PROMOTE_SUCCESS": "Els canvis de l'esborrany s'han publicat a l'article actiu",
        "PROMOTE_ERROR": "No s'han pogut publicar els canvis de l'esborrany",
        "DISCARD_SUCCESS": "S'han descartat els canvis de l'esborrany",
        "DISCARD_ERROR": "No s'han pogut descartar els canvis de l'esborrany"
      },
      "VERSION_HISTORY": {
        "MENU_ITEM": "Historial de versions",
        "TITLE": "Historial de versions",
        "BACK": "Torna a l'article",
        "LOADING": "S'estan carregant les versions...",
        "EMPTY": "Encara no hi ha versions. Els canvis d'aquest article apareixeran aquí.",
        "EMPTY_CONTENT": "Aquesta versió no té contingut.",
        "CURRENT_BADGE": "Actual",
        "RESTORED_BADGE": "Restaurada",
        "AUTOMATED_USER": "Actualització automàtica",
        "RESTORE": "Restaura aquesta versió",
        "RESTORE_DIALOG": {
          "TITLE": "Vols restaurar aquesta versió?",
          "DESCRIPTION": "L'article tornarà a la redacció d'aquesta versió. No es perd res — el text actual es manté a l'historial, i un article publicat continua mostrant la versió activa fins que publiquis el canvi.",
          "CONFIRM": "Restaura"
        },
        "RESTORE_SUCCESS": "S'ha restaurat la versió",
        "RESTORE_ERROR": "No s'ha pogut restaurar aquesta versió",
        "FETCH_ERROR": "No s'ha pogut carregar l'historial de versions"
      },
      "EDIT_ARTICLE": {
        "MORE_PROPERTIES": "Més propietats",
        "TRANSLATE": "Tradueix",
        "SOURCE": "Markdown",
        "UNCATEGORIZED": "Sense categoria",
        "EDITOR_PLACEHOLDER": "Escriu alguna cosa...",
        "HTML_EMBED": {
          "TITLE": "Insereix HTML personalitzat",
          "DESCRIPTION": "Enganxa codi HTML pur com un iframe, un embed o un fragment de widget. Es mostrarà tal qual a l'article publicat.",
          "PLACEHOLDER": "<iframe src=\"https://...\"></iframe>",
          "INSERT": "Insereix"
        },
        "PRIMARY_CATEGORY": "Categoria principal"
      },
      "ARTICLE_PROPERTIES": {
        "ARTICLE_PROPERTIES": "Propietats de l'article",
        "SLUG": "Slug",
        "EDIT_SLUG": "Edit slug",
        "META_DESCRIPTION": "Meta descripció",
        "META_DESCRIPTION_PLACEHOLDER": "Afegeix una meta descripció",
        "META_TITLE": "Meta títol",
        "META_TITLE_PLACEHOLDER": "Afegeix un meta títol",
        "META_TAGS": "Meta etiquetes",
        "META_TAGS_PLACEHOLDER": "Afegeix meta etiquetes",
        "SET_AS_HOMEPAGE": "Set as homepage",
        "SET_AS_HOMEPAGE_HELP": "Show this article as the help center homepage for this language. Add {'{{NAV}}'} in the content to include search + categories.",
        "LANGUAGE_MUTATIONS": "Variants d'idioma",
        "LANGUAGE_MUTATIONS_EMPTY": "Encara no hi ha articles vinculats",
        "ADD_MUTATION": "Afegeix",
        "REMOVE_MUTATION": "Elimina"
      },
      "LANGUAGE_MUTATIONS_DIALOG": {
        "TITLE": "Vincula variants d'idioma",
        "SEARCH_PLACEHOLDER": "Cerca articles per títol",
        "EMPTY": "Cap article coincident",
        "CANCEL": "Cancel·la",
        "ADD_SELECTED": "Afegeix la selecció",
        "SUCCESS": "Variants actualitzades",
        "ERROR": "Error en actualitzar les variants"
      },
      "TRANSLATE_DIALOG": {
        "TITLE": "Tradueix l'article",
        "DESCRIPTION": "Selecciona els idiomes als quals vols traduir aquest article. Els idiomes que ja estan traduïts es tornaran a traduir a un esborrany per revisar.",
        "EMPTY": "No hi ha cap altre idioma disponible",
        "CONNECTED_BADGE": "Traduït",
        "CANCEL": "Cancel·la",
        "TRANSLATE": "Tradueix",
        "SUCCESS": "La traducció començarà aviat. Els articles traduïts apareixeran aviat com a variants d'idioma.",
        "ERROR": "No s'ha pogut iniciar la traducció"
      },
      "SLUG_DIALOG": {
        "TITLE": "Edit article URL",
        "DESCRIPTION": "Change the descriptive part of this article's slug. Old links keep working — they redirect here automatically.",
        "INPUT_LABEL": "Slug",
        "PLACEHOLDER": "getting-started",
        "PREFIX_HINT": "The numeric prefix is a permanent identifier and cannot be changed.",
        "PREVIEW": "Article URL",
        "CANCEL": "Cancel",
        "SAVE": "Save",
        "SUCCESS": "Article URL updated",
        "ERROR": "Failed to update the article URL"
      },
      "API": {
        "ERROR": "S'ha produït un error en desar l'article"
      }
    },
    "PORTAL_SWITCHER": {
      "NEW_PORTAL": "Nou portal",
      "PORTALS": "Portals",
      "CREATE_PORTAL": "Crea i gestiona diversos portals",
      "ARTICLES": "articles",
      "DOMAIN": "domini",
      "PORTAL_NAME": "Nom del portal"
    },
    "CREATE_PORTAL_DIALOG": {
      "TITLE": "Crea un portal nou",
      "DESCRIPTION": "Dona un nom al teu portal i crea un slug d'URL fàcil d'utilitzar. Podràs modificar-los més endavant a la configuració.",
      "CONFIRM_BUTTON_LABEL": "Crea",
      "NAME": {
        "LABEL": "Nom",
        "PLACEHOLDER": "Guia d'usuari",
        "MESSAGE": "Tria un nom per al teu portal.",
        "ERROR": "El nom és obligatori"
      },
      "SLUG": {
        "LABEL": "Slug",
        "PLACEHOLDER": "user-guide",
        "ERROR": "El slug és obligatori",
        "FORMAT_ERROR": "Utilitzeu només lletres, números i guions, per exemple: user-guide"
      }
    },
    "PORTAL_SETTINGS": {
      "FORM": {
        "AVATAR": {
          "LABEL": "Logo",
          "IMAGE_UPLOAD_ERROR": "No s'ha pogut carregar la imatge! Torna-ho a provar",
          "IMAGE_UPLOAD_SUCCESS": "Imatge afegida correctament. Fes clic a desar els canvis per desar el logo",
          "IMAGE_DELETE_SUCCESS": "El logotip s'ha suprimit correctament",
          "IMAGE_DELETE_ERROR": "No s'ha pogut suprimir el logotip",
          "IMAGE_UPLOAD_SIZE_ERROR": "La mida de la imatge ha de ser inferior a {size}MB"
        },
        "HERO_IMAGE": {
          "LABEL": "Hero image",
          "HELP_TEXT": "Optional full-width background image shown behind the centered search box on the help center homepage.",
          "IMAGE_UPLOAD_ERROR": "Couldn't upload image! Try again",
          "IMAGE_UPLOAD_SUCCESS": "Image added successfully. Please click on save changes to save the hero image",
          "IMAGE_DELETE_SUCCESS": "Hero image deleted successfully",
          "IMAGE_DELETE_ERROR": "Unable to delete hero image",
          "IMAGE_UPLOAD_SIZE_ERROR": "Image size should be less than {size}MB"
        },
        "HOMEPAGE_ARTICLES": {
          "LABEL": "Homepage articles",
          "EMPTY": "No article is set as the homepage. Set one from an article's properties.",
          "HELP_TEXT": "The article shown as the homepage for each language. Click to open it, or remove to restore the default homepage.",
          "REMOVE": "Remove",
          "REMOVE_SUCCESS": "Homepage article removed",
          "REMOVE_ERROR": "Unable to remove homepage article"
        },
        "NAME": {
          "LABEL": "Nom",
          "PLACEHOLDER": "Nom del portal",
          "ERROR": "El nom és obligatori"
        },
        "HEADER_TEXT": {
          "LABEL": "Text de la capçalera",
          "PLACEHOLDER": "Text de la capçalera del portal"
        },
        "PAGE_TITLE": {
          "LABEL": "Títol de la pàgina",
          "PLACEHOLDER": "Títol de la pàgina del portal"
        },
        "HOME_PAGE_LINK": {
          "LABEL": "Enllaç a la pàgina d'inici",
          "PLACEHOLDER": "Enllaç a la pàgina d'inici del portal",
          "ERROR": "URL no vàlida. L'enllaç a la pàgina d'inici ha de començar amb 'http://' o 'https://'."
        },
        "SLUG": {
          "LABEL": "Slug",
          "PLACEHOLDER": "Slug del portal"
        },
        "LIVE_CHAT_WIDGET": {
          "LABEL": "Widget de xat en directe",
          "PLACEHOLDER": "Selecciona el widget de xat en directe",
          "HELP_TEXT": "Selecciona un widget de xat en directe que apareixerà al teu centre d'ajuda"
        },
        "PUBLIC_ACCESS": {
          "LABEL": "Accessible públicament",
          "HELP_TEXT": "Fes que el portal sigui accessible per a tothom amb l'enllaç.",
          "OPTIONS": {
            "PUBLIC": "Sí",
            "PRIVATE": "No"
          }
        },
        "LINK_TARGET": {
          "LABEL": "Destinació de l'enllaç",
          "HELP_TEXT": "Trieu si els enllaços dins dels articles s'obren a la finestra actual o en una de nova.",
          "OPTIONS": {
            "CURRENT_WINDOW": "Finestra actual",
            "NEW_WINDOW": "Finestra nova"
          }
        },
        "DEFAULT_IMAGE_SIZE": {
          "LABEL": "Mida predeterminada de la imatge",
          "HELP_TEXT": "Mida que s'aplica a cada imatge que insereixis en un article. Selecciona Original per inserir les imatges amb la seva pròpia mida i triar una mida per a cada imatge en lloc d'això."
        },
        "BRAND_COLOR": {
          "LABEL": "Color de marca"
        },
        "CUSTOM_HTML": {
          "LABEL": "HTML personalitzat",
          "PLACEHOLDER": "<!-- Enganxa aquí el teu fragment d'analítica o seguiment -->",
          "HELP_TEXT": "S'insereix al començament de l'etiqueta <body> a totes les pàgines del centre d'ajuda. Utilitza'l per a Google Analytics, Google Tag Manager o qualsevol altre fragment de seguiment. El codi es renderitza exactament tal com s'ha introduït i no es valida."
        },
        "SAVE_CHANGES": "Desa els canvis"
      },
      "CONFIGURATION_FORM": {
        "CUSTOM_DOMAIN": {
          "HEADER": "Domini personalitzat",
          "LABEL": "Domini personalitzat:",
          "DESCRIPTION": "Pots allotjar el teu portal en un domini personalitzat. Per exemple, si el teu lloc web és eldomini.com i vols que el teu portal estigui disponible a docs.eldomini.com, simplement introdueix-ho en aquest camp.",
          "PLACEHOLDER": "Domini personalitzat del portal",
          "EDIT_BUTTON": "Edita el domini personalitzat",
          "ADD_BUTTON": "Afegeix domini personalitzat",
          "DIALOG": {
            "ADD_HEADER": "Afegeix domini personalitzat",
            "EDIT_HEADER": "Edita el domini personalitzat",
            "ADD_CONFIRM_BUTTON_LABEL": "Afegeix domini",
            "EDIT_CONFIRM_BUTTON_LABEL": "Actualitza el domini",
            "LABEL": "Domini personalitzat",
            "PLACEHOLDER": "Domini personalitzat del portal",
            "ERROR": "El domini personalitzat és obligatori"
          },
          "DNS_CONFIGURATION_DIALOG": {
            "HEADER": "Configuració DNS",
            "DESCRIPTION": "Inicia sessió al compte que tens amb el teu proveïdor de DNS i afegeix el registre CNAME següent per al teu subdomini.",
            "HELP_TEXT": "Un cop fet això, pots contactar amb el nostre equip de suport per sol·licitar el certificat SSL generat automàticament.",
            "CONFIRM_BUTTON_LABEL": "Entesos!"
          }
        },
        "DELETE_PORTAL": {
          "BUTTON": "Suprimeix {portalName}",
          "HEADER": "Suprimir portal",
          "DESCRIPTION": "Suprimeix aquest portal de manera permanent. Aquesta acció és irreversible",
          "DIALOG": {
            "HEADER": "Segur que vols suprimir {portalName}?",
            "DESCRIPTION": "Aquesta és una acció permanent que no es pot desfer.",
            "CONFIRM_BUTTON_LABEL": "Suprimeix"
          }
        },
        "EDIT_CONFIGURATION": "Edita la configuració"
      },
      "API": {
        "CREATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal creat correctament",
          "ERROR_MESSAGE": "No es pot crear el portal"
        },
        "UPDATE_PORTAL": {
          "SUCCESS_MESSAGE": "Portal actualitzat correctament",
          "ERROR_MESSAGE": "No es pot actualitzar el portal"
        }
      }
    },
    "ATTACHMENTS": {
      "TITLE": "Fitxers adjunts",
      "DRAFT_BADGE": "Draft",
      "ADD_BUTTON": "Afegeix fitxer",
      "DROP_HERE": "Arrossega i deixa anar els fitxers aquí",
      "COPY_LINK": "Copia l'enllaç",
      "LINK_COPIED": "Enllaç copiat al porta-retalls",
      "COPY_FAILED": "No s'ha pogut copiar l'enllaç",
      "DELETE": "Suprimeix",
      "CANCEL": "Cancel·la",
      "QUEUED": "A la cua",
      "UPLOADING": "Carregant",
      "UPLOAD_FAILED": "No s'ha pogut carregar el fitxer",
      "FILE_TOO_LARGE": "El fitxer supera el límit de mida de 40 MB"
    },
    "DICTIONARY_PAGE": {
      "HEADER": {
        "TITLE": "Diccionari de traducció",
        "DESCRIPTION": "Els termes definits aquí s'afegeixen a les instruccions de traducció de la IA, de manera que sempre es tradueixin de la mateixa manera. El terme clau s'escriu en {locale}."
      },
      "NEW_TERM": "Nou terme",
      "EMPTY_STATE": {
        "TITLE": "Encara no hi ha termes al diccionari",
        "SUBTITLE": "Afegeix un terme i la seva traducció per a cada idioma. Quan es tradueix un article, aquests termes s'apliquen perquè el llenguatge del teu producte es mantingui coherent."
      },
      "LIST": {
        "TERM": "Terme",
        "TRANSLATIONS": "Traduccions",
        "ACTIONS": "Accions"
      },
      "DICTIONARY_DIALOG": {
        "HEADER": {
          "CREATE": "Afegeix un terme",
          "EDIT": "Edita el terme",
          "DESCRIPTION": "El terme següent s'aplica durant la traducció amb IA dels articles del teu centre d'ajuda.",
          "PORTAL": "Portal",
          "PRIMARY_LANGUAGE": "Idioma principal"
        },
        "FORM": {
          "TERM": {
            "LABEL": "Terme ({locale})",
            "PLACEHOLDER": "Inbox",
            "ERROR": "El terme és obligatori"
          },
          "DESCRIPTION": {
            "LABEL": "Context / notes (opcional)",
            "PLACEHOLDER": "Quan i com s'utilitza aquest terme, per ajudar el traductor a desambiguar-lo."
          },
          "TRANSLATIONS": "Traduccions",
          "TRANSLATION_PLACEHOLDER": "Deixa-ho buit perquè la IA tradueixi lliurement",
          "AUTO_TRANSLATE": {
            "BUTTON": "Tradueix-ho tot amb IA",
            "CONFIRM": "Tradueix a {count} idiomes amb IA?",
            "CONFIRM_BUTTON": "Tradueix",
            "CANCEL": "Cancel·la",
            "SUCCESS": "Traduccions generades — revisa-les i desa-les",
            "ERROR": "No s'ha pogut traduir automàticament. Torna-ho a provar."
          }
        },
        "BUTTONS": {
          "CREATE": "Afegeix el terme",
          "EDIT": "Desa",
          "CANCEL": "Cancel·la"
        },
        "CREATE": {
          "API": {
            "SUCCESS_MESSAGE": "El terme s'ha afegit correctament",
            "ERROR_MESSAGE": "No s'ha pogut afegir el terme. Torna-ho a provar."
          }
        },
        "EDIT": {
          "API": {
            "SUCCESS_MESSAGE": "El terme s'ha actualitzat correctament",
            "ERROR_MESSAGE": "No s'ha pogut actualitzar el terme. Torna-ho a provar."
          }
        }
      },
      "DELETE": {
        "CONFIRM": {
          "TITLE": "Suprimeix el terme",
          "DESCRIPTION": "Estàs segur que vols suprimir aquest terme? Ja no s'aplicarà durant la traducció.",
          "CONFIRM": "Suprimeix"
        },
        "API": {
          "SUCCESS_MESSAGE": "Terme suprimit correctament",
          "ERROR_MESSAGE": "No s'ha pogut suprimir el terme. Torna-ho a provar."
        }
      }
    }
  }
}
